import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
    import Select from 'react-select';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useLoading } from '../../../context/LoadingContext';
// import ReactTooltip from 'react-tooltip';
import { Modal, Button, Table } from 'react-bootstrap';
import { AiOutlinePrinter } from "react-icons/ai";
import socket from "../../../socket";


const Leave = () => {
    const { setLoading } = useLoading();
    const isStaff = localStorage.getItem('role') === 'employee';
    let sessionUser = {};
    try {
        sessionUser = JSON.parse(localStorage.getItem('adminData') || 'null')?.user || {};
    } catch {
        // Missing session identity must not fall back to employee selection.
    }
    const staffName = [sessionUser.first, sessionUser.middle, sessionUser.last]
        .map(part => (part || '').trim()).filter(Boolean).join(' ');
    const getStaffIdentity = () => isStaff ? {
        emp_db_id: sessionUser.id || '',
        emp_id: sessionUser.emp_id || '',
        emp_name: staffName
    } : {};
    const canAccessLeave = leave => !isStaff || Boolean(
        sessionUser.id && sessionUser.emp_id && leave &&
        String(leave.emp_db_id) === String(sessionUser.id) &&
        String(leave.emp_id).trim() === String(sessionUser.emp_id).trim()
    );
    const [showHRNoteModal, setShowHRNoteModal] = useState(false);
    const [selectedHRNote, setSelectedHRNote] = useState('');
    const [selectedLeaveData, setSelectedLeaveData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    // console.log(adminData);
    //===================== useStates==================
    const [confirmDelete, setConfirmDelete] = useState({
        show: false,
        id: null
    });
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const getTodayDate = () => {
        const today = new Date();
        if (isStaff) {
            return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        }
        return today.toISOString().split('T')[0];
    }
    const [employeeList, setEmployeeList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [finalData, setFinalData] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [leaveTypeList, setLeaveTypeList] = useState([])
    const [formData, setFormData] = useState({
        emp_db_id: '',
        leave_type: '',
        leave_date: getTodayDate(),
        from_date: '',
        to_date: '',
        reason: '',
        total_days: '',
        total_amount: '',
        address: '',
        approval_status: 'Pending',
        encashable: 0,
        ...getStaffIdentity()
    })

        useEffect(() => {

        socket.on("leave-review", (data) => {
            showToast(data.message, "info");
        });

        return () => socket.off("leave-review");
    }, []);


    //===================== handlers==================
    const handlePrint = () => {
        if (!canAccessLeave(selectedLeaveData)) return;
        window.print();
    };

    const handleSelectLeaveForPrint = (data) => {
        if (!canAccessLeave(data)) return;
        setSelectedLeaveData(data);
        setShowModal(true);
    };

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };


    const handleFormOpen = () => {
        setShowForm(true);
        setIsEditing(false);
        setEditingId(null);
        setFormData({
            emp_db_id: '',
            leave_type: '',
            leave_date: getTodayDate(),
            from_date: '',
            to_date: '',
            reason: '',
            total_days: '',
            total_amount: '',
            address: '',
            approval_status: 'Pending',
            ...getStaffIdentity()
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;

        const updatedFormData = {
            ...formData,
            [name]: value
        };


        if (name === 'from_date' || name === 'to_date') {
            const fromDate = new Date(
                name === 'from_date' ? value : formData.from_date
            );
            const toDate = new Date(
                name === 'to_date' ? value : formData.to_date
            );

            if (!isNaN(fromDate) && !isNaN(toDate)) {
                const diffTime = toDate - fromDate;
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

                updatedFormData.total_days = diffDays > 0 ? diffDays : '';
            }
        }

        setFormData(updatedFormData);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isStaff && (!sessionUser.id || !sessionUser.emp_id || !staffName)) {
            showToast('Logged-in employee details are unavailable. Please log in again.', 'danger');
            return;
        }
        try {
            const payload = {
                ...formData,
                ...getStaffIdentity(),
                ...(isStaff && !isEditing ? { leave_date: getTodayDate() } : {}),
                total_amount: formData.total_amount === '' ? null : formData.total_amount
            };

            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-leave/${editingId}`, payload);
                showToast('Leave Updated Successfully', 'success');
                console.log("Server response", res.data.message);

                setFinalData(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...payload } : itm)
                );

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-leave', payload);
                showToast('Leave added successfully!', 'success');
                console.log("Server reponse", res.data.message);

                setFinalData(prev => [
                    ...prev,
                    { id: res.data.insertId, ...payload }
                ]);
            }
            fetchLeave();
            setFormData({
                emp_db_id: '',
                leave_type: '',
                leave_date: getTodayDate(),
                from_date: '',
                to_date: '',
                reason: '',
                total_days: '',
                total_amount: '',
                address: '',
                approval_status: 'Pending',
                encashable: 0,
                ...getStaffIdentity()
            });


            setShowForm(false);
            setIsEditing(false);
            setEditingId(null);
        } catch (error) {
            console.error(error);
            showToast('Error adding leave application', 'danger');
        }
    }

    const handleEdit = (id) => {

        const data = finalData.find(item => item.id === id);
        if (!data) return;
        if (!canAccessLeave(data)) {
            showToast('You can only edit your own leave application.', 'danger');
            return;
        }

        const leaveType = leaveTypeList.find(It => It.leave_name === data.leave_type);
        const encashable = leaveType ? leaveType.encashable : 0;

        setEditingId(id);

        setFormData({
            ...data,
            encashable: encashable,
            total_amount: data.total_amount || '',
            ...getStaffIdentity()
        });
        setIsEditing(true);
        setShowForm(true);
        // console.log('Editing encashable:', data.encashable);
    };

    const handleConfirmDelete = async (id) => {
        if (!confirmDelete.id) return;
        if (isStaff && !canAccessLeave(finalData.find(item => item.id === confirmDelete.id))) {
            showToast('You can only delete your own leave application.', 'danger');
            setConfirmDelete({ show: false, id: null });
            return;
        }
        try {
            const response = await axios.delete(`https://api.skyguard.group/api/delete-leave/${confirmDelete.id}`);
            // const data = response.data;
            showToast('Leave deleted successfully!', 'success');
            fetchLeave();

            setFinalData(prev => prev.filter(item => item.id !== confirmDelete.id));

            if (isEditing && editingId === confirmDelete.id) {
                setIsEditing(false);
                setEditingId(null);
                setShowForm(false);
                setFormData({
                    // emp_id: '',
                    leave_type: '',
                    leave_date: '',
                    from_date: '',
                    to_date: '',
                    reason: '',
                    // emp_name: '',
                    total_days: '',
                    total_amount: '',
                    address: '',
                    approval_status: 'Pending',
                    encashable: 0,
                    ...(isStaff ? { ...getStaffIdentity(), leave_date: getTodayDate() } : {})
                })
            }
        } catch (error) {
            console.error('Error deleting leave:', error);
            showToast('Error deleting Leave', 'danger');

        } finally {
            setConfirmDelete({ show: false, id: null });
        }
    };

    const handleCancelDelete = () => {
        setConfirmDelete({ show: false, id: null });
    };

// console.log(finalData,'this is final data');

    // const filteredData = finalData.filter(itm =>
    //     Object.values(itm).some(val =>
    //         String(val).toLowerCase().includes(searchTerm.toLowerCase())
    //     )
    // )

    const filteredData = (finalData || []).filter(canAccessLeave).filter(itm =>
    Object.values(itm || {}).some(val =>
        String(val || "").toLowerCase().includes(searchTerm.toLowerCase())
    )
);


    // const emp_idOptions = [
    //     { value: 'EPM101', label: 'EPM101' },
    //     { value: 'EPM102', label: 'EPM102' },
    //     { value: 'EPM103', label: 'EPM103' }
    // ];
    const LeaveTypeOptions = [
        { value: 'Casual Leave', label: 'Casual Leave' },
        { value: 'Sick Leave', label: 'Sick Leave' },
        { value: 'Previlaged Leave', label: 'Previlaged Leave' }
    ]




    // ===========api=============

    const fetchEmployeeData = async () => {
        if (isStaff) return;
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            // console.log(data);

            const formatted = data
             .filter(emp => emp.emp_id)   
            .map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: `${emp.emp_id}`,
                    empName: fullName
                }
            });
            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    }

    const fetchLeaveMaster = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-leave-master');
            setLeaveTypeList(res.data.result);

        } catch (error) {
            console.error("Error fetching Leave Master:", error);
        }
    }

    const fetchLeave = async () => {
        setLoading(true);
        try {
            if (isStaff && (!sessionUser.id || !sessionUser.emp_id)) {
                setFinalData([]);
                return;
            }
            const res = await axios.get('https://api.skyguard.group/api/fetch-leave', isStaff ? {
                params: { role: 'employee', emp_id: sessionUser.emp_id }
            } : undefined);
            setFinalData((res.data.result || []).filter(canAccessLeave));
        } catch (error) {
            if (isStaff) setFinalData([]);
            console.error("Error fetching Leave Application", error);
        } finally {
            setLoading(false);
        }
    }



    useEffect(() => {
        if (!isStaff) fetchEmployeeData();
        fetchLeaveMaster();
        fetchLeave();
    }, [])

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Leave Application</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <div className='row'>


                        {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.leave_date}
    </span>
  </div>
)}                              
                                {/* left side */}
                                <div className='col-md-6'>
                                    <div className='row g-3'>
                                        {/* Employee id */}
                                        <div className="col-12">
                                            <label className="form-label fw-medium">{isStaff ? 'Employee ID' : 'Select Emp ID'}</label>
                                            {isStaff ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="emp_id"
                                                    value={sessionUser.emp_id || ''}
                                                    readOnly
                                                />
                                            ) : (
                                            <Select
                                                options={employeeList}
                                                value={employeeList.find(opt => opt.id === formData.emp_db_id) || null}
                                                onChange={(selectedOption) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        emp_db_id: selectedOption.id,
                                                        emp_id: selectedOption.value,
                                                        emp_name: selectedOption.empName
                                                    }))
                                                }}
                                            />
                                            )}
                                        </div>
                                        {/* Leave Date */}
                                        <div className="col-12">
                                            <label className="form-label fw-medium">Leave Apply Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="leave_date"
                                                value={formData.leave_date}
                                                onChange={handleChange}
                                                readOnly={isStaff}
                                            />
                                        </div>

                                        {/* from/to days */}
                                        <div className="col-12">
                                            <div className='row g-2'>
                                                <div className='col-md-6'>
                                                    <label className="form-label fw-medium">From Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="from_date"
                                                        value={formData.from_date}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <label className="form-label fw-medium">To Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="to_date"
                                                        value={formData.to_date}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Reason */}
                                        <div className='col-12'>
                                            <label htmlFor="reason" className='form-label fw-medium'>Reason</label>
                                            <textarea
                                                className="form-control"
                                                id="reason"
                                                name="reason"
                                                rows="5"
                                                value={formData.reason}
                                                onChange={handleChange}
                                                placeholder="Enter here..."
                                            ></textarea>
                                        </div>

                                    </div>
                                </div>
                                {/* right side */}
                                <div className='col-md-6'>
                                    <div className='row g-3'>
                                        {/* Employee Name */}
                                        <div className="col-12">
                                            <label className="form-label fw-medium">Employee Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="emp_name"
                                                value={isStaff ? staffName : formData.emp_name}
                                                onChange={handleChange}
                                                readOnly
                                            />
                                        </div>

                                        {/* Leave Type*/}
                                        <div className="col-12">
                                            <label className="form-label fw-medium">Select Leave Type</label>
                                            <Select
                                                options={leaveTypeList.map(item => ({
                                                    value: item.leave_name,
                                                    label: item.leave_name,
                                                    encashable: item.encashable
                                                }))}
                                                value={
                                                    leaveTypeList
                                                        .map(item => ({
                                                            value: item.leave_name,
                                                            label: item.leave_name,
                                                            encashable: item.encashable
                                                        }))
                                                        .find(opt => opt.value === formData.leave_type) || null
                                                }
                                                onChange={(selectedOption) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        leave_type: selectedOption.value,
                                                        encashable: selectedOption.encashable
                                                    }));
                                                }}
                                                placeholder="Select Leave Type"
                                            />
                                        </div>

                                        {/* Total Days/Amount */}
                                        <div className='col-12'>
                                            <div className='row g-2'>
                                                <div className='col-md-6'>
                                                    <label className="form-label fw-medium">Total Days</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="total_days"
                                                        value={formData.total_days}
                                                        onChange={handleChange}
                                                        readOnly
                                                    />
                                                </div>
                                                {Number(formData.encashable) === 1 && (
                                                    <div className='col-md-6'>
                                                        <label className="form-label fw-medium">Total Amount</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="total_amount"
                                                            value={formData.total_amount}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* Address */}
                                        <div className='col-12'>
                                            <label htmlFor="address" className='form-label fw-medium'>Address</label>
                                            <textarea
                                                className="form-control"
                                                id="address"
                                                name="address"
                                                rows="5"
                                                placeholder="Enter here..."
                                                value={formData.address}
                                                onChange={handleChange}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* save/Cancel */}
                            <div className='d-flex justify-content-center mt-4 gap-2'>
                                <button type='button' className='btn btn-success'
                                    onClick={handleSubmit}
                                >
                                    {isEditing ? 'UPDATE' : 'SAVE'}
                                </button>
                                <button
                                    type='button'
                                    className='btn btn-danger'
                                    onClick={() => {
                                        setShowForm(false);
                                        setIsEditing(false);
                                        setEditingId(null);
                                        setFormData({
                                            emp_id: '',
                                            leave_type: '',
                                            leave_date: '',
                                            from_date: '',
                                            to_date: '',
                                            reason: '',
                                            emp_name: '',
                                            total_days: '',
                                            total_amount: '',
                                            address: '',
                                            ...(isStaff ? { ...getStaffIdentity(), leave_date: getTodayDate() } : {})
                                        });
                                    }}
                                >
                                    Cancel
                                </button>

                            </div>
                        </div>
                    )}
                    {/*  Main- table */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                        <th>Action</th>
                                    <th>Name</th>
                                    <th>Apply Date</th>
                                    <th>Leave Type</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Total Days</th>
                                    <th>Approval</th>
                                    <th>HR Note</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((data, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                                <td>
                                                <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(data.id)}><AiOutlineEdit size={18} /></button>
                                                <button
                                                    className='btn btn-sm btn-danger mx-1'
                                                    onClick={() => setConfirmDelete({ show: true, id: data.id })}
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                                <button
                                                    className='btn btn-sm btn-secondary mx-1'
                                                    onClick={() => handleSelectLeaveForPrint(data)}
                                                >
                                                    Print
                                                </button>

                                            </td>
                                            <td>{data.emp_name}</td>
                                            <td>{data.leave_date}</td>
                                            <td>{data.leave_type}</td>
                                            <td>{data.from_date}</td>
                                            <td>{data.to_date}</td>
                                            <td>{data.total_days}</td>
                                            <td>
                                                {data.approval_status === 'Approved' ? (
                                                    <span className='badge bg-success'>{data.approval_status}</span>
                                                ) : data.approval_status === 'Rejected' ? (
                                                    <span className='badge bg-danger'>{data.approval_status}</span>
                                                ) : (
                                                    <span className='badge bg-warning text-dark'>{data.approval_status}</span>
                                                )}
                                            </td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    variant="info"
                                                    onClick={() => {
                                                        setSelectedHRNote(data.hr_note || 'Pending...');
                                                        setShowHRNoteModal(true);
                                                    }}
                                                >
                                                    View Note
                                                </Button>
                                            </td>
                                        
                                        </tr>
                                    ))) : (
                                    <tr>
                                        <td colSpan="9" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                        <Modal.Header closeButton style={{ borderBottom: '2px solid #007bff' }}>
                            <Modal.Title style={{ fontSize: '26px', fontWeight: '600', color: '#007bff' }}>
                                Leave Application Details
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: '#f4f6f8', borderRadius: '8px', padding: '30px' }}>
                            <div style={{ fontFamily: 'Arial, sans-serif', color: '#333', minHeight: '300px' }}>
                                <h3 style={{ textAlign: 'center', marginBottom: '25px', fontSize: '24px', color: '#333' }}>
                                    Leave Details
                                </h3>

                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '16px' }}>
                                    <tbody>
                                        {[
                                            ['Employee Name', selectedLeaveData?.emp_name],
                                            ['Leave Type', selectedLeaveData?.leave_type],
                                            ['Apply Date', selectedLeaveData?.leave_date],
                                            ['From Date', selectedLeaveData?.from_date],
                                            ['To Date', selectedLeaveData?.to_date],
                                            ['Total Days', selectedLeaveData?.total_days],
                                            ['Reason', selectedLeaveData?.reason],
                                            ['Address', selectedLeaveData?.address],
                                            ['Approval Status', selectedLeaveData?.approval_status],
                                            ['HR Note', selectedLeaveData?.hr_note],
                                        ].map(([label, value], index) => (
                                            <tr
                                                key={index}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f0f2f5',
                                                }}
                                            >
                                                <td style={{ padding: '12px 15px', fontWeight: '600', width: '35%' }}>{label}</td>
                                                <td style={{ padding: '12px 15px' }}>{value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ textAlign: 'center', marginTop: '25px' }}>
                                    <Button
                                        variant="primary"
                                        onClick={handlePrint}
                                        style={{
                                            fontSize: '16px',
                                            padding: '10px 25px',
                                            fontWeight: '600',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        <AiOutlinePrinter size={20} />
                                        Print Leave Details
                                    </Button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal> */}
                    <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
                        <Modal.Header closeButton style={{ borderBottom: '2px solid #007bff' }}>
                            <Modal.Title style={{ fontSize: '26px', fontWeight: '600', color: '#007bff' }}>
                                Leave Application Details
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ backgroundColor: '#f4f6f8', borderRadius: '8px', padding: '30px' }}>
                            <div style={{ fontFamily: 'Arial, sans-serif', color: '#333', minHeight: '300px' }}>
                                <h3 style={{ textAlign: 'center', marginBottom: '25px', fontSize: '24px', color: '#333' }}>
                                    Leave Details
                                </h3>

                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '16px' }}>
                                    <tbody>
                                        {[
                                            ['Employee Name', selectedLeaveData?.emp_name],
                                            ['Leave Type', selectedLeaveData?.leave_type],
                                            ['Apply Date', selectedLeaveData?.leave_date],
                                            ['From Date', selectedLeaveData?.from_date],
                                            ['To Date', selectedLeaveData?.to_date],
                                            ['Total Days', selectedLeaveData?.total_days],
                                            ['Reason', selectedLeaveData?.reason],
                                            ['Address', selectedLeaveData?.address],
                                            ['Approval Status', selectedLeaveData?.approval_status],
                                            ['HR Note', selectedLeaveData?.hr_note],
                                        ].map(([label, value], index) => (
                                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f0f2f5' }}>
                                                <td style={{ padding: '12px 15px', fontWeight: '600', width: '35%' }}>{label}</td>
                                                <td style={{ padding: '12px 15px' }}>{value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="print-hide" style={{ textAlign: 'center', marginTop: '25px' }}>
                                    <Button
                                        variant="primary"
                                        onClick={handlePrint}
                                        style={{
                                            fontSize: '16px',
                                            padding: '10px 25px',
                                            fontWeight: '600',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                        }}
                                    >
                                        <AiOutlinePrinter size={20} />
                                        Print Leave Details
                                    </Button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>


                </div>
            </div>

            <Modal show={showHRNoteModal} onHide={() => setShowHRNoteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>HR Note</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{selectedHRNote}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowHRNoteModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast(prev => ({ ...prev, show: false }))}
            />

            <ConfirmDialog
                show={confirmDelete.show}
                title="Delete Leave"
                message="Are you sure you want to delete this leave ?"
                onConfirm={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />
            <style jsx>
                {`
    @media print {
      /* Hide everything except the modal content */
      body * {
        visibility: hidden;
      }

      .modal-content, .modal-content * {
        visibility: visible;
      }

      /* Set modal content to fit A4 paper */
      .modal-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background: white;
        padding: 20px;
      }

      /* Hide print button during print */
      .print-hide {
        display: none;
      }

      /* Ensuring other elements are styled correctly during printing */
      .modal-header, .modal-body {
        border: none !important;
      }
    }
  `}
            </style>

        </>
    )
}
export default Leave
